const overviewActionTypes = {
    SET_LOADING: 'SET_LOADING',
    SET_FIELD_GROUP: 'SET_FIELD_GROUP',
    SHOW_CHART: "SHOW_CHART",
    SAVE_INDEX_COMPONENTS: "SAVE_INDEX_COMPONENTS",
    SET_OVERVIEW_DATA: 'SET_OVERVIEW_DATA',
    CLEAR_OVERVIEW: 'CLEAR_OVERVIEW'
}


export default overviewActionTypes
